<app-nav></app-nav>
<section class="aboutUs">
    <div class="container">
      <div class="col">
          <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow_logo.svg">
      </div>
      <div class="col">
          <h2 class="heading">Version 1.0.0</h2>
      </div>
      <div class="col">
       <p><b>About us :</b> SecureNow is an award winning technology-focused insurance broker well placed in the industry to provide you a wide range of commercial and individual insurance products. We are a board member of the Insurance Brokers Association of India and have the rich and wide connects across the Insurance industry to provide you with competitive rates and comprehensive support for claims, as a single point of contact.
          <br><br>
          <b>SecureNow App:</b> The SecureNow App is a progressive web app which is light, fast to use and user-friendly. All your insurance products and services now are available to you at one place. This app helps you to buy insurance, view all your policies across insurers and even register claims, from one screen. For quick access during an emergency your family’s health E-cards and a Hospital locator are provided. You can get multiple quotes for policy purchase in seconds and enjoy better benefits at better prices through our App.</p>
      </div>
      <div class="col">
        <!-- <a href="https://securenow.in/terms-of-use/terms">User Agreement, Terms and services</a> -->
        <a href="https://securenow.in/terms-of-use/terms-and-conditions">User Agreement, Terms and services</a>
      </div>
    </div>
  </section>
